export default function SearchBarLocation() {
    return {
        restrict: "E",
        //require : '^searchBar',
        template: require("./template.html"),

        // link: function(scope, element, attrs, $ctrl) {
        //     //console.log( $ctrl );
        // },
        // controller: function($scope) {
        //     /**
        //      * note: No Scope defined -> aka same as parent
        //      */
        // }
    };
}
